module.exports = __webpack_public_path__ + "img/achieve-area.b7fdb8e.png";